// extracted by mini-css-extract-plugin
export var container = "_59-0";
export var disabled = "_59-4";
export var fullWidth = "_59-3";
export var lined = "_59-1";
export var selected = "_59-5";
export var tab = "_59-2";